var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 11L11.8122 1L23 11"}));
}

Close.defaultProps = {"width":"24","height":"12","viewBox":"0 0 24 12","fill":"none","stroke":"#231F20"};

module.exports = Close;

Close.default = Close;
